const MARKDOWN_IGNORE_IDENTIFIER = '|markdownIgnoreSeparator|'

const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const ignoreBlockElements = (markdown: string) => {
    markdown = markdown || ''

    const lines = markdown.split(/\r?\n/)

    // We simply add a weird sequence of chars at the begining to prevent
    // headings, block quotes, lists, etc
    return lines.map((line) => `${MARKDOWN_IGNORE_IDENTIFIER}${line}`).join('\n')
}

const unignoreBlockElements = (html: string) => {
    const escapedIdentifier = escapeRegExp(MARKDOWN_IGNORE_IDENTIFIER)
    return html.replace(new RegExp(escapedIdentifier, 'g'), '')
}

export { ignoreBlockElements, unignoreBlockElements, MARKDOWN_IGNORE_IDENTIFIER }
